import { FactAlert } from './FactAlert';
import { formatDateTimeRange } from '@/shared/lib/dates';
import { messages } from '@/shared/constants/messages';
import type { SpaceConflict } from '@/shared/types/domain';

interface SpaceConflictPanelProps {
  conflicts: readonly SpaceConflict[];
  isLoading: boolean;
}

/**
 * O alerta do REVISOR (US-20, §4.6/§5.1) — detalhe completo, ao contrário do
 * `ConflictAlert` do líder (`components/form/`), que só diz QUE está ocupado.
 * Aqui o rótulo, o ministério e o horário vêm da RPC, já autorizada por
 * `can_decide_for_ministry`.
 *
 * **Veste a moldura de `FactAlert`** (decisão 36): a partir da 3ª rodada ele
 * mora ao lado de "Local", no documento, e se repete dentro do formulário de
 * aprovação (US-22). Duas caixas âmbar de formatos diferentes na mesma tela
 * fariam o leitor procurar uma diferença de significado que não existe.
 *
 * Nunca bloqueia (regra 5 / ADR-004): some quando não há conflito, e é isso —
 * nenhum estado de "tudo certo" precisa ser afirmado.
 */
export function SpaceConflictPanel({ conflicts, isLoading }: SpaceConflictPanelProps) {
  if (isLoading || conflicts.length === 0) return null;

  return (
    <FactAlert title={messages.review.spaceConflictTitle}>
      {messages.review.spaceConflictHint}

      <ul className="mt-2 space-y-2">
        {conflicts.map((conflict) => (
          <li
            key={`${conflict.label}-${conflict.starts_at}-${conflict.space_name}`}
            className="rounded-md bg-white/60 p-2"
          >
            <p className="font-medium text-amber-950">{conflict.label}</p>
            <p className="text-xs text-amber-900/80">
              {conflict.ministry_name} · {conflict.space_name} ·{' '}
              {formatDateTimeRange(conflict.starts_at, conflict.ends_at)}
            </p>
          </li>
        ))}
      </ul>
    </FactAlert>
  );
}
